import Clipboard from 'clipboard';
import * as angular from 'angular';
import { passwordGrade } from '../../../../../../util/password-strength';

//import { resolve } from '../../../../../init/store';

export class Controller {

    /** @ngInject */
    constructor($state, $scope, Alert, ConfirmDeleteModal, SharedAccountsService, ConfirmModal) {
        this.Alert = Alert;
        this.ConfirmDeleteModal = ConfirmDeleteModal;
        this.ConfirmModal = ConfirmModal;
        this.SharedAccountsService = SharedAccountsService;
        this.$state = $state;
        this.$scope = $scope;
    }

    $onInit() {
        this.tooltipTemplate = require('../../secret-tooltip.html');
        new Clipboard(".copyCli").on('success', () => {
            this.$scope.$apply(() => {
            this.Alert('success', 'global.data_copied')
            })
        })
		if (Object.keys(this.sharedAccount).length === 0) {
                this.$state.go('^');
    	}
        this.$account =  {...this.sharedAccount};//{...this.resolve.account};
        this.account = {...this.$account};
        this.passGrade=passwordGrade(this.account.password);
        this.publicServicesWithSso$.get().then(items => this.publicServices=items);
        this.searchItem = this.account.publicService.serviceName !== 'Other' ? this.account.publicService.serviceName : 'Custom';

        if(this.convert2fa) {
            this.changeToConvertState();
        }
        this.isCustom = this.$account.publicService.slug == 'other';
    }

    saveIcon(iconFile) {
        const formData = new FormData();
        formData.append('iconFile', iconFile);
        return this.SharedAccountsService.uploadCustomIconForCorporateServiceAccount(
            {
                companyId: this.companyId, //resolve.companyId,
                corporateServiceAccountId: this.account.id,
            },
            formData
        )
            .$promise
            .then((data) => {
                this.account.customIcon = data.customIcon;
                this.Alert('success', 'company.sharing-center.manage.saved');
            });
    }

    resetIcon() {
        return this.ConfirmModal({
            messageKey:'Custom icon will be deleted and default icon will be used. Do you want to continue?',
            titleKey:'Confirm Delete'
        })
        .then(() =>
            this.SharedAccountsService.deleteCustomIconForCorporateServiceAccount(
                    {
                        companyId: this.companyId, //resolve.companyId,
                        corporateServiceAccountId: this.account.id,
                    }
                )
                .$promise
                .then(() => {
                    this.account.customIcon = null;
                    this.Alert('success', 'company.sharing-center.manage.saved');
                })
        )
    }

    createCopy() {
        let copyAccount = {
            username: this.sharedAccount.username,
            password: this.sharedAccount.password,
            note: this.sharedAccount.note,
            showOtpEnabled: this.sharedAccount.showOtpEnabled,
            showPasswordEnabled: this.sharedAccount.showPasswordEnabled,
            showNoteEnabled: this.sharedAccount.showNoteEnabled,
            publicService: this.publicServices.find(i => i.slug === "other"),
            customServiceName: this.getCopyServiceName(),
            serviceLoginUrl: this.sharedAccount.publicService.slug === 'other' ? this.sharedAccount.serviceLoginUrl : this.sharedAccount.publicService.serviceUrl
        };
        this.$state.go("company.sharing-center.add-shared-password",{copyAccount:copyAccount});
    }

    getCopyServiceName() {
        let currentServiceName = this.sharedAccount.publicService.slug === 'other' ? this.sharedAccount.customServiceName : this.sharedAccount.publicService.serviceName;
        let customServiceNames = this.allAccounts.filter(account => account.username === this.sharedAccount.username && account.publicService.slug === 'other' && account.customServiceName != null).map(item => {
            return item.customServiceName;
        });
        currentServiceName = currentServiceName.indexOf(' Copy') !== -1 ? currentServiceName.substring(0, currentServiceName.indexOf(' Copy')) : currentServiceName;
        let copyServiceName = currentServiceName + ' Copy';
        if (customServiceNames.indexOf(copyServiceName) === -1) {
            return copyServiceName;
        }
        
        let i = 1;
        while (customServiceNames.indexOf(copyServiceName + ' ' + i) !== -1) {
            i++;
        }
        return copyServiceName + ' ' + i;
    }
    
    changePassGrade(){
		this.passGrade=passwordGrade(this.account.password);
	}

    notModified() {
        if (this.$account.publicService.id === this.account.publicService.id) {
            this.account.publicService = this.$account.publicService;
        }
        return angular.equals(this.$account, this.account);
    }

    selectCustom() {
        this.searchItem = 'Custom';
        this.account.publicService = this.publicServices.find(i => i.slug === "other");
    }

    serviceSelected(service) {
        this.account.publicService = service;
        if (service.slug !== "other") {
            this.account.customServiceName = null;
        }
    }

    isComputerAdministrationAccount() {
        return this.account.publicService.serviceName == 'ComputerLocalAccountAdministration';
    }

    remove() {
        this.isRemoving = true;
        this.ConfirmDeleteModal('groups_users.confirm_company_user_account_delete')
            .then(() => this.SharedAccountsService.deleteCompanyServiceAccounts({
                companyId: this.companyId,//resolve.companyId,
                id: this.account.id,
            }).$promise)
            .then(() => {
                //this.close();
                this.$state.go('^.^', {}, {reload: '^.^'});
                this.Alert('success', 'company.sharing-center.manage.removed');
            })
            .finally(() => this.isRemoving = false)
    }

    save() {
        this.isSaving = true;
        this.SharedAccountsService.updateCompanyServiceAccounts(
            {
                companyId: this.companyId, //resolve.companyId,
                publicServiceId: this.account.publicService.id,
            },
            {
                id: this.account.id,
                username: this.account.username,
                password: this.account.password,
                serviceLoginUrl: this.account.serviceLoginUrl,
                enabled2fa: false,
                showOtpEnabled: false,
                showPasswordEnabled: this.account.showPasswordEnabled,
                showNoteEnabled: this.account.showNoteEnabled,
                note: this.account.note,
                customServiceName: this.account.customServiceName,
            }
        )
            .$promise
            .then(account => {
                this.Alert('success', 'company.sharing-center.manage.saved');
                this.$state.reload('company.sharing-center.shared-passwords');
                this.updateSharedAccountWithNewValues(this.sharedAccount, account);
                this.$account =  {...this.sharedAccount};//{...this.resolve.account};
                this.account = {...this.$account};
            })
            .finally(() => this.isSaving = false)
    }

    saveDisabled(form) {
        return this.isSaving || form.$invalid || this.notModified();
    }
    convertDisabled(form) {
        return this.isSaving || form.$invalid;
    }
    changeToConvertState(){
		this.convert=true;
		   this.authenticator = {
            algorithm: 'SHA1',
            digits: 6,
            showOtpEnabled: false,
            secret: ''
            
        };
	}
	convertToAuth(){
		this.isSaving = true;
        this.SharedAccountsService.convertCompanyServiceAccountToAuth(
            {
                companyId: this.companyId, //resolve.companyId,
                publicServiceId: this.account.publicService.id,
            },
            {
                id: this.account.id,
                username: this.account.username,
                password: this.account.password,
                serviceLoginUrl: this.account.serviceLoginUrl,
                enabled2fa: true,
                showOtpEnabled: this.authenticator.showOtpEnabled,
                showPasswordEnabled: this.account.showPasswordEnabled,
                showNoteEnabled: this.account.showNoteEnabled,
                note: this.account.note,
                customServiceName: this.account.customServiceName,
                publicServiceKey: generatePublicServiceKey(
                    this.account.publicService.serviceName,
                    this.account.username,
                    this.authenticator.secret,
                    this.authenticator.digits,
                    this.authenticator.algorithm,
                ),
            }
        )
            .$promise
            .then(account => {
                //this.close({$value: account});
                this.$state.go('company.sharing-center.shared-authenticators.manage.edit', {sharedAccount: account, sharedAccountId: account.id});
                this.Alert('success', 'company.sharing-center.manage.saved');
            })
            .finally(() => this.isSaving = false)
	}

    updateSharedAccountWithNewValues(sharedAccount, newAccount) {
        sharedAccount.publicService = newAccount.publicService;
        sharedAccount.username = newAccount.username;
        sharedAccount.password = newAccount.password;
        sharedAccount.serviceLoginUrl = newAccount.serviceLoginUrl;
        sharedAccount.enabled2fa = newAccount.enabled2fa;
        sharedAccount.showOtpEnabled = newAccount.showOtpEnabled;
        sharedAccount.showPasswordEnabled = newAccount.showPasswordEnabled;
        sharedAccount.showNoteEnabled = newAccount.showNoteEnabled;
        sharedAccount.note = newAccount.note;
        sharedAccount.customServiceName = newAccount.customServiceName455f;
        sharedAccount.publicServiceKey = newAccount.publicServiceKey;
        sharedAccount.username = newAccount.username;
        sharedAccount.username = newAccount.username;
    }
}

function generatePublicServiceKey(issuer, username, secretKey, digits, algorithm) {
    const secret = secretKey.replace(/\s/g, '');
    return `otpauth://totp/${issuer}:${username}?secret=${secret}&issuer=${issuer}&digits=${digits}&algorithm=${algorithm}`;
}



// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-passwords/manage/manage-shared-password.controller.js